import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSeo } from "../../hooks/useSeo";
import { articles, channelName, channels } from "../../mocks/chigua";
import ArticleCard from "../../components/feature/ArticleCard";

export default function ArticleDetail() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);
  const [liked, setLiked] = useState(false);
  const [follow, setFollow] = useState(false);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useSeo({
    title: `${article ? article.title : "吃瓜爆料"} - 今天吃瓜`,
    description: article ? `${article.summary} 今天吃瓜提供本期吃瓜爆料全文与后续追踪。` : "今天吃瓜吃瓜爆料详情",
    keywords: article ? article.tags.join(",") : "今天吃瓜,吃瓜爆料",
    path: `/baoliao/${article ? article.id : ""}`,
    schemas: article
      ? [
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://fish3.cn/" },
              { "@type": "ListItem", position: 2, name: "吃瓜爆料", item: "https://fish3.cn/baoliao" },
              { "@type": "ListItem", position: 3, name: article.title, item: `https://fish3.cn/baoliao/${article.id}` },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "Article",
            headline: article.title,
            description: article.summary,
            image: article.image,
            articleSection: channelName(article.channel),
            inLanguage: "zh-CN",
            author: { "@type": "Organization", name: "今天吃瓜" },
            publisher: { "@type": "Organization", name: "今天吃瓜" },
            mainEntityOfPage: `https://fish3.cn/baoliao/${article.id}`,
          },
        ]
      : [],
  });

  if (!article) {
    return (
      <div className="mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center">
        <i className="ri-error-warning-line text-5xl text-background-400" aria-hidden="true" />
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">这条瓜没找到</h1>
        <p className="mt-2 text-sm text-foreground-500">内容可能已被整理下架，去爆料库看看别的新瓜吧。</p>
        <Link to="/baoliao" className="mt-6 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600">
          返回吃瓜爆料库
        </Link>
      </div>
    );
  }

  const related = articles.filter((a) => a.id !== article.id).slice(0, 3);
  const channel = channels.find((c) => c.key === article.channel);

  return (
    <article className="bg-background-50">
      <div className="mx-auto max-w-4xl px-4 py-8 md:px-6">
        <nav className="flex items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑">
          <Link to="/" className="hover:text-primary-600">首页</Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true" />
          <Link to="/baoliao" className="hover:text-primary-600">吃瓜爆料</Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true" />
          <Link to={`/baoliao?channel=${article.channel}`} className="hover:text-primary-600">{channelName(article.channel)}</Link>
        </nav>

        <header className="mt-6">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">{channelName(article.channel)}</span>
            {article.hot && (
              <span className="flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                <i className="ri-flashlight-fill" aria-hidden="true" /> 正在发酵
              </span>
            )}
            <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">{channel?.tagline}</span>
          </div>
          <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">{article.title}</h1>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">{article.summary}</p>
          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 border-y border-background-200 py-4 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-account-circle-line text-lg" aria-hidden="true" />
              </span>
              今天吃瓜编辑组
            </span>
            <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{article.time}发布</span>
            <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />阅读约{article.readingTime}</span>
            <span className="flex items-center gap-1"><i className="ri-eye-line" aria-hidden="true" />{article.views} 围观</span>
          </div>
        </header>

        {/* cover */}
        <figure className="mt-7 overflow-hidden rounded-2xl">
          <img src={article.image} alt={article.title} className="h-auto w-full object-cover" />
        </figure>

        {/* body */}
        <div className="mt-8 flex flex-col gap-5 text-[15px] leading-8 text-foreground-700">
          {article.content.map((para, i) => (
            <p key={i} className="first:indent-0">{para}</p>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          {article.tags.map((t) => (
            <Link
              key={t}
              to={`/baoliao?q=${encodeURIComponent(t)}`}
              className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition hover:bg-secondary-500 hover:text-background-50"
            >
              #{t}
            </Link>
          ))}
        </div>

        {/* actions */}
        <div className="mt-8 flex flex-col gap-3 rounded-2xl bg-background-100/70 p-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => setLiked((v) => !v)}
              className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition ${
                liked ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700 hover:text-primary-700"
              }`}
            >
              <i className={liked ? "ri-heart-3-fill" : "ri-heart-3-line"} aria-hidden="true" />
              {liked ? "已围观" : "吃瓜捧场"}
            </button>
            <button
              type="button"
              onClick={() => setFollow((v) => !v)}
              className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition ${
                follow ? "bg-accent-500 text-background-50" : "bg-background-50 text-foreground-700 hover:text-accent-700"
              }`}
            >
              <i className={follow ? "ri-notification-fill" : "ri-notification-3-line"} aria-hidden="true" />
              {follow ? "已在追更" : "追更后续"}
            </button>
          </div>
          <div className="flex items-center gap-1.5 text-sm text-foreground-500">
            <span className="mr-1">分享</span>
            <a
              href={`mailto:?subject=${encodeURIComponent(article.title)}&body=${encodeURIComponent(`https://fish3.cn/baoliao/${article.id}`)}`}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition hover:text-primary-600"
              aria-label="邮件分享"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
            </a>
          </div>
        </div>

        {/* disclaimer */}
        <div className="mt-6 flex gap-3 rounded-xl border border-secondary-200 bg-secondary-50 p-5 text-sm leading-relaxed text-secondary-900">
          <i className="ri-information-line mt-0.5 text-secondary-600" aria-hidden="true" />
          <p>
            <strong>理性吃瓜提示：</strong>本文为对公开网络热议信息的整理呈现，事件进展请以官方说明或当事人回应为准。
            若内容涉及您的合法权益，可通过「联系我们」页与我们取得联系，我们会及时核实处理。
          </p>
        </div>

        {/* related */}
        <section className="mt-12 border-t border-background-200 pt-10">
          <div className="mb-5 flex items-center justify-between">
            <h2 className="font-heading text-2xl font-black text-foreground-950">猜你还想吃这些瓜</h2>
            <Link to="/baoliao" className="text-sm font-medium text-primary-600 hover:text-primary-700">查看更多 ›</Link>
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {related.map((a) => (
              <ArticleCard key={a.id} article={a} layout="card" />
            ))}
          </div>
        </section>
      </div>

      {/* back to top */}
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="回到顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-background-50 shadow transition hover:bg-primary-700 ${
          showTop ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line" aria-hidden="true" />
      </button>
    </article>
  );
}